import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a359592"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "amount-content" }
const _hoisted_2 = { class: "pvd-modal__heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/prgw/digital/finewissues/client/assets/money.svg",
  alt: "Money bill"
}, null, -1))
const _hoisted_4 = {
  id: "amountContentHeader",
  slot: "heading"
}
const _hoisted_5 = { id: "amountContentSubHeader" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "grayBar",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { class: "amount-field" }
const _hoisted_8 = { class: "helperText" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-reader-only" }, "(Goes to next page of modal)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd_link = _resolveComponent("pvd-link")!
  const _component_FdicModal = _resolveComponent("FdicModal")!
  const _component_apex_currency = _resolveComponent("apex-currency")!
  const _component_pvd_inline_alert = _resolveComponent("pvd-inline-alert")!
  const _component_pvd_microcopy = _resolveComponent("pvd-microcopy")!
  const _component_pvd_button = _resolveComponent("pvd-button")!
  const _component_pvd_field_group = _resolveComponent("pvd-field-group")!
  const _component_pvd_form = _resolveComponent("pvd-form")!
  const _component_pvd_progress_indicator = _resolveComponent("pvd-progress-indicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_HEADER), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, _toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_SUB_HEADER), 1),
      _createVNode(_component_pvd_link, {
        id: "amountFdicLink",
        "pvd-native-anchor-attributes": "{\"style\":\"text-align:center\"}",
        "pvd-trigger": "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.clientConstants.FDIC_LINK), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_FdicModal, { ref: "fdicModal" }, null, 512)
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_pvd_form, {
        "pvd-dense": "",
        "pvd-novalidate": "true",
        ref: "amountForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_pvd_field_group, { id: "amount-field-group" }, {
            default: _withCtx(() => [
              _createVNode(_component_apex_currency, {
                id: "amountContentInput",
                label: _ctx.clientConstants.AMOUNT_CONTENT_INPUT_HEADER,
                value: _ctx.amountValue,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.amountChanged($event)))
              }, null, 8, ["label", "value"]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createVNode(_component_pvd_inline_alert, {
                  id: "amount-content-input-error",
                  "pvd-size": "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_INPUT_ERROR), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.amountInvalid]
                ]),
                _withDirectives(_createVNode(_component_pvd_inline_alert, {
                  id: "amount-content-max-error",
                  "pvd-size": "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_MAX_LIMIT_ERROR), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.amountMaxExceeded]
                ]),
                _createVNode(_component_pvd_microcopy, { id: "helper-text-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_HELPER_TEXT_1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_pvd_microcopy, { id: "helper-text-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_HELPER_TEXT_2), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_pvd_button, {
                "pvd-full-width": "",
                id: "next-button",
                onClick: _ctx.nextButtonClicked,
                "pvd-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.clientConstants.NEXT_BUTTON) + " ", 1),
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_pvd_progress_indicator, {
      "pvd-active-step-index": "0",
      "pvd-steps": "[\"\",\"\", \"\"]"
    })
  ]))
}